import styled from "@emotion/styled";
import TuneIcon from "@mui/icons-material/Tune";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;

  inline-size: 100%;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 10px;
  align-items: center;

  inline-size: 100%;
  padding-block-end: 16px;
  border-block-end: 1px #dfdfdf solid;
`;

export const StyledTuneIcon = styled(TuneIcon)`
  inline-size: 16px;
  block-size: 16px;

  color: #000000;
`;

export const Title = styled.p`
  flex: 1 1 auto;

  margin: 0;

  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const ResetButton = styled.button`
  padding: 0;

  color: #2c4692;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  border: none;

  background-color: transparent;

  cursor: pointer;
`;
